export const LANDING_PAGE_URL = 'https://magicdispatch.com';
export const API_DOCS_URL = process.env.REACT_APP_API_DOCS_URL;
